

// Local HTML-only transition study. The existing scene compositions are kept
// at their original dimensions: desktop trims only their unused outer canvas.
const main=document.querySelector('#continut.cinematic-story');
if(main){
 const body=document.body,legacy=[...main.querySelectorAll(':scope>.scene')].filter(n=>n.id!=='campioni');
 const sections=[...main.querySelectorAll(':scope>section')],footer=document.querySelector('.site-footer'),joins=[];
 const rooms=legacy.map(scene=>{
  const canvas=scene.querySelector(':scope>.r7-scene-canvas');return{scene,canvas};
 });
 for(let i=0;i<sections.length;i++){
  const node=sections[i],next=sections[i+1]||footer;if(!next)continue;
  const seam=node.querySelector(':scope>.r7-seam');if(seam){seam.dataset.from=node.id;seam.dataset.to=next.id;}
  joins.push({node,next});
 }
 body.classList.add('tos-r7');
 let scheduled=false,measurements=0;
 const read=()=>{
  scheduled=false;
  joins.forEach(({node,next})=>node.style.setProperty('--r7-next-color',getComputedStyle(next).backgroundColor));
  if(!matchMedia('(min-width:701px)').matches){
   rooms.forEach(({scene})=>{delete scene.__r7Geometry;});
   return;
  }
  // Single synchronous measure/commit on resize/font changes, never on scroll.
  // Keep the desktop containing block stable while reading native min-heights:
  // toggling display:contents here can leave WebKit container units stale.
  body.classList.add('r7-measuring');
  const tokens=getComputedStyle(body),start=parseFloat(tokens.getPropertyValue('--r7-start')),end=parseFloat(tokens.getPropertyValue('--r7-end'));
  rooms.forEach(({scene})=>scene.style.setProperty('--r7-native-min-height',getComputedStyle(scene).minHeight));
  const values=rooms.map(({scene,canvas})=>{
   const parts=[...canvas.children].filter(n=>n.matches('.scene__art,.story-card,.field-note,.open-seat-note')&&n.offsetHeight>0);
   const baseHeight=canvas.clientHeight;
   const origin=canvas.getBoundingClientRect().top,rects=parts.map(n=>n.getBoundingClientRect());
   const top=parts.length?Math.min(...rects.map(r=>r.top))-origin:0;
   const bottom=parts.length?Math.max(...rects.map(r=>r.bottom))-origin:baseHeight;
   // Keep 32px above and 48px below visible content. Never cut into its box.
   // Signed trim also reserves space for tall tablet cards which already extend
   // beyond the baseline canvas. Their native size and overlap stay untouched.
   const trimTop=top-start,trimBottom=baseHeight-bottom-end;
   return{scene,canvas,baseHeight,top,bottom,trimTop,trimBottom};
  });
  for(const value of values){
   const {scene,baseHeight,trimTop,trimBottom}=value;
   scene.style.setProperty('--r7-original-height',baseHeight+'px');
   scene.style.setProperty('--r7-trim-top',trimTop+'px');
   scene.style.setProperty('--r7-trim-bottom',trimBottom+'px');
   scene.__r7Geometry={baseHeight,contentTop:value.top,contentBottom:value.bottom,trimTop,trimBottom};
  }
  body.classList.remove('r7-measuring');
  measurements++;
 };
 const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(read);}};
 const observer=new ResizeObserver(schedule);
 rooms.forEach(({canvas})=>canvas.querySelectorAll('.story-card,.field-note,.open-seat-note').forEach(n=>observer.observe(n)));
 window.addEventListener('resize',schedule,{passive:true});
 document.fonts.ready.then(schedule);document.fonts.addEventListener('loadingdone',schedule);
 window.addEventListener('load',schedule,{once:true});
 document.addEventListener('load',event=>{if(event.target instanceof HTMLLinkElement)schedule();},true);
 read();window.__TOS_R7_SEAMS__={rooms,read,get measurements(){return measurements;}};
}
